





















































































































































































import Results from "@/components/Results.vue";
import Spinner from "vue-simple-spinner";
import Voters from "@/components/Voters.vue";
import _ from "lodash";
import assert from "assert";
import sleep from "sleep-promise";
import { Election, Trustee, Vue } from "@/types.ts";
import { VueGoodTable } from "vue-good-table";

export default Vue.extend({
  components: {
    Results,
    Spinner,
    Voters,
    Vuetable: VueGoodTable,
  },
  computed: {
    ballots(): string {
      const election = this.election;
      assert(election);
      const blob = new Blob(
        election.ballots
          ? _.map(election.ballots, ballot => JSON.stringify(ballot))
          : [],
        {
          type: "text/plain",
        }
      );
      return window.URL.createObjectURL(blob);
    },
    election(): Election | null {
      return this.elections?.get(this.uuid) || null;
    },
    elections(): Map<string, Election> | null {
      const state = this.$store.state;
      assert(state.electionsTracker);
      return state.elections;
    },
    code(): string | null {
      const code = this.$route.query["code"] || null;
      if (Array.isArray(code)) return code[0] || null;
      else return code || null;
    },
    self(): Trustee | null {
      assert(this.election);
      return (
        _.find(this.election.externalTrustees, t => t.email === this.email) ||
        null
      );
    },
  },
  data() {
    return {
      decryption: null as string | null,
      electionFingerprint: null as string | null,
      error: null as string | null,
      generating: false,
      keyInput: "",
      lastCheck: null as Date | null,
      loadingElection: false,
      privateKey: null as string | null,
      timer: null as number | null,
    };
  },
  methods: {
    async checkProgress() {
      const { election, self } = this;
      assert(election);
      if (election.voters === undefined) return;
      if (!this.electionFingerprint)
        this.electionFingerprint = electionFingerprint(election);
      const now = new Date();
      if (
        this.lastCheck === null ||
        now.getTime() - this.lastCheck.getTime() >= 60 * 60 * 1000
      )
        try {
          await checkElection(this.electionFingerprint, election);
          this.lastCheck = now;
        } catch (e) {
          await this.$store.dispatch("log", {
            election,
            line: `critical election validation error: ${e.toString()}`,
          });
        }
      if (!self) return;
      assert(election.externalTrustees);
      if (
        this.privateKey &&
        self.threshold &&
        !self.polynomials &&
        _.every(election.externalTrustees, t => t.credentials)
      ) {
        const p = polynomials(
          election.externalTrustees,
          this.privateKey,
          election.threshold
        );
        await this.$store.dispatch("addTrustee", {
          election: this.election,
          trustee: { ...self, polynomials: p },
          code: this.code,
        });
      } else if (
        this.privateKey &&
        self.threshold &&
        !self.voutput &&
        _.every(election.externalTrustees, t => t.vinput)
      ) {
        assert(self.vinput);
        const v = voutput(
          election.externalTrustees,
          this.privateKey,
          self.vinput
        );
        await this.$store.dispatch("addTrustee", {
          election: this.election,
          trustee: { ...self, voutput: v },
          code: this.code,
        });
      } else if (this.privateKey && !self.partial && election.tallyEncrypted)
        this.decrypt();
    },
    async decrypt() {
      const { election, privateKey, self } = this;
      assert(election);
      assert(privateKey);
      assert(self);
      this.generating = true;
      this.error = null;
      await sleep(400);
      try {
        const partial = self.voutput
          ? decryptThresholdTally(election, privateKey, self.voutput)
          : decryptTally(election, `"${privateKey}"`);
        await this.$store.dispatch("decrypt", {
          election,
          trustee: self,
          partial,
        });
        this.decryption = partial;
      } catch (e) {
        this.error = "Clé de déchiffrement invalide.";
        this.generating = false;
      }
    },
    formatTime(date: Date) {
      return `${date.toLocaleDateString("fr-FR")} ${date.toLocaleTimeString(
        "fr-FR"
      )}`;
    },
    inputKey() {
      this.privateKey = this.keyInput;
    },
    async generate() {
      const { self } = this;
      assert(self);
      this.generating = true;
      await sleep(400);
      const trustee = generateTrustee(this.email, self.threshold);
      await this.$store.dispatch("addTrustee", {
        election: this.election,
        trustee,
        code: this.code,
      });
      this.privateKey = trustee.credentials.priv.replace(/"/g, "");
    },
    async loadElection(): Promise<void> {
      this.loadingElection = true;
      await this.$store.dispatch("loadElection", {
        code: this.code,
        email: this.email,
        uuid: this.uuid,
      });
      this.loadingElection = false;
    },
  },
  mounted(): void {
    const period = 60000;
    const refresh = async () => {
      await this.loadElection();
      this.timer = _.delay(refresh, period);
    };
    this.timer = _.delay(refresh, period);
    this.loadElection();
  },
  // unmounted(): void {
  //   if (this.timer) clearTimeout(this.timer);
  // },
  name: "Trustee",
  props: {
    email: { type: String, required: true },
    uuid: { type: String, required: true },
  },
  watch: {
    election: {
      handler(election) {
        this.checkProgress();
      },
      deep: true,
    },
    uuid: {
      async handler() {
        const state = this.$store.state;
        if (state.email === null && !state.elections?.has(this.uuid))
          await this.loadElection();
      },
      immediate: true,
    },
  },
});
